<template>
    <v-select
        v-if="transferPointsList && transferPointsList.length"
        item-title="name"
        :items="transferPointsList"
        return-object
        item-value="name"
        :label="$t('select_hotel_or_manual_point')"
        :prepend-inner-icon="pointSelected && pointSelected.type === 'hotel' ? 'mdi-office-building' : 'mdi-map-marker'"
        @update:model-value="change($event)"
    >
        <template v-slot:item="data">
            <v-list-item v-bind="data.props">
                <template v-slot:title>
                    <div class="d-flex align-center">
                        <v-icon size="small" class="me-2 text-medium-emphasis">
                            {{ data.item.raw.type === 'HOTEL' ? 'mdi-office-building' : 'mdi-map-marker' }}
                        </v-icon>
                        <span v-html="data.item.raw.name" />
                    </div>
                </template>
            </v-list-item>
        </template>
    </v-select>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class TransferBookingFormsLocationSelection extends Vue {
        @Prop() pointSelected
        @Prop() transferPointsList

        @Emit()
        change(point) {
            return point
        }
    }

    export default TransferBookingFormsLocationSelection
</script>
